// extracted by mini-css-extract-plugin
module.exports = {"swiper-button":"SwiperToggleButton_swiper-button__MxCbZ","swiper-icon":"SwiperToggleButton_swiper-icon__0x5Na"};